import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc CallItemNotesWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { CallItemNotesWidgetService } from 'services/callItemNotesWidgetWidget';
 *
 * // create service instance and send/cancel request
 * const callItemNotesWidgetService = new CallItemNotesWidgetService();
 * const result = await callItemNotesWidgetService.fetchData( '<user-id>' ); // fetch data
 * callItemNotesWidgetService.cancel(); // cancel an active request
 */
export class CallItemNotesWidgetService extends HttpService {

    // fetch call list data
    async fetchComponentData( { url = {}, data = {}, memberId = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data,
                memberId
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component', {} ),
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

}
